import './App.css';

import React, { Component } from 'react';
import Game from '../Game/Game';

class App extends Component {
  componentDidMount() {
    // Force the height to not include the address bar
    this.setHeight();
    window.addEventListener('resize', this.setHeight);

    // Detect IE
    if (/Trident/.test(window.navigator.appVersion)) {
      document.documentElement.classList.add('is-ie');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setHeight);
  }

  setHeight = () => {
    this.appEl.style.height = `${window.innerHeight}px`;
    setTimeout(this.setHeight, 500);
  }

  handleRef = (ref) => {
    this.appEl = ref;
  }

  render() {
    return (
      <div className="App" ref={this.handleRef}>
        <Game />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/rlgl/App/App.js